// BusinessDetailsSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import WorkingHoursSection from "./WorkingHoursSection";

const BusinessDetailsSection = ({ form, errors, setForm, handleInputChange }) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        padding: "0",
        width: "100%",
        maxWidth: "960px",
        margin: "0 auto",
      }}
      dir={i18n.dir()}
      lang={i18n.language}
    >
    {/* Registration Details Card */}
    <div style={{
      background: "#fff",
      padding: "24px",
      marginBottom: "32px"
    }}>
      <h3 style={{ 
        fontSize: "18px", 
        fontWeight: "600", 
        color: "#1f2937",
        marginBottom: "20px"
      }}>
        {t("clinicSetup.business.title")}
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <div>
            <label style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px"
            }}>
              {t("clinicSetup.business.fields.registrationNumber.label")} <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="text"
              name="registrationNumber"
              value={form.registrationNumber}
              onChange={handleInputChange}
              placeholder={t("clinicSetup.business.fields.registrationNumber.placeholder")}
              style={{
                width: "100%",
                maxWidth: "450px",
                padding: "12px 16px",
                fontSize: "15px",
                border: errors.registrationNumber ? "2px solid #ef4444" : "2px solid #e5e7eb",
                borderRadius: "10px",
                outline: "none",
                transition: "all 0.2s ease",
                background: "#fff",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#3b82f6";
                e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = errors.registrationNumber ? "#ef4444" : "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.registrationNumber && (
              <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
                {errors.registrationNumber}
              </div>
            )}
          </div>
          <div>
            <label style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px"
            }}>
              {t("clinicSetup.business.fields.vatNumber.label")} <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="text"
              name="vatNumber"
              value={form.vatNumber}
              onChange={handleInputChange}
              placeholder={t("clinicSetup.business.fields.vatNumber.placeholder")}
              style={{
                width: "100%",
                maxWidth: "450px",
                padding: "12px 16px",
                fontSize: "15px",
                border: errors.vatNumber ? "2px solid #ef4444" : "2px solid #e5e7eb",
                borderRadius: "10px",
                outline: "none",
                transition: "all 0.2s ease",
                background: "#fff",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#3b82f6";
                e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = errors.vatNumber ? "#ef4444" : "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.vatNumber && (
              <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
                {errors.vatNumber}
              </div>
            )}
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <div>
            <label style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px"
            }}>
              {t("clinicSetup.business.fields.currency.label")} <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <select
              name="currency"
              value={form.currency}
              onChange={handleInputChange}
              style={{
                width: "100%",
                maxWidth: "450px",
                padding: "12px 40px 12px 16px",
                fontSize: "15px",
                border: errors.currency ? "2px solid #ef4444" : "2px solid #e5e7eb",
                borderRadius: "10px",
                outline: "none",
                cursor: "pointer",
                background: "#fff",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 16px center",
                boxSizing: "border-box",
                transition: "all 0.2s ease",
                appearance: "none"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#3b82f6";
                e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = errors.currency ? "#ef4444" : "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
            >
              <option value="" disabled>
                {t("clinicSetup.business.fields.currency.placeholder")}
              </option>
              <option value="JOD">JOD</option>
              <option value="USD">USD</option>
              <option value="SAR">SAR</option>
              <option value="AED">AED</option>
              <option value="EUR">EUR</option>
            </select>
            {errors.currency && (
              <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
                {errors.currency}
              </div>
            )}
          </div>
          <div>
            <label style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px"
            }}>
              {t("clinicSetup.business.fields.invoiceStart.label")} <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              type="text"
              name="invoiceStart"
              value={form.invoiceStart}
              onChange={handleInputChange}
              placeholder={t("clinicSetup.business.fields.invoiceStart.placeholder")}
              style={{
                width: "100%",
                maxWidth: "450px",
                padding: "12px 16px",
                fontSize: "15px",
                border: errors.invoiceStart ? "2px solid #ef4444" : "2px solid #e5e7eb",
                borderRadius: "10px",
                outline: "none",
                transition: "all 0.2s ease",
                background: "#fff",
                boxSizing: "border-box"
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#3b82f6";
                e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
              }}
              onBlur={(e) => {
                if (e.target.value.length === 0) {
                  e.target.value = "1";
                  handleInputChange(e);
                }
                e.target.style.borderColor = errors.invoiceStart ? "#ef4444" : "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.invoiceStart && (
              <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
                {errors.invoiceStart}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Working Hours Section */}
    <WorkingHoursSection form={form} setForm={setForm} errors={errors} handleInputChange={handleInputChange} />
  </div>
);
};

export default BusinessDetailsSection;
